import { supabase } from './supabase';

export async function setupInspectionPhotosBucket() {
  if (!supabase) return;

  try {
    // Create the inspection-photos bucket if it doesn't exist
    const { data: bucket, error: bucketError } = await supabase.storage.createBucket('inspection-photos', {
      public: true,
      fileSizeLimit: 5242880, // 5MB limit per file
    });

    if (bucketError && bucketError.message !== 'Bucket already exists') {
      throw bucketError;
    }

    // Set up storage policies
    const { error: policyError } = await supabase.storage.from('inspection-photos').createSignedUrl('test.txt', 60);

    if (policyError) {
      // Create policies if they don't exist
      const { error: insertPolicyError } = await supabase.rpc('create_storage_policy', {
        bucket_name: 'inspection-photos',
        policy_name: 'Allow authenticated users to upload photos',
        policy_definition: `
          (bucket_id = 'inspection-photos' AND auth.role() = 'authenticated')
        `,
        policy_permissions: 'INSERT'
      });

      if (insertPolicyError) {
        console.error('Error creating insert policy:', insertPolicyError);
      }

      const { error: selectPolicyError } = await supabase.rpc('create_storage_policy', {
        bucket_name: 'inspection-photos',
        policy_name: 'Allow authenticated users to read photos',
        policy_definition: `
          (bucket_id = 'inspection-photos' AND auth.role() = 'authenticated')
        `,
        policy_permissions: 'SELECT'
      });

      if (selectPolicyError) {
        console.error('Error creating select policy:', selectPolicyError);
      }

      const { error: deletePolicyError } = await supabase.rpc('create_storage_policy', {
        bucket_name: 'inspection-photos',
        policy_name: 'Allow authenticated users to delete photos',
        policy_definition: `
          (bucket_id = 'inspection-photos' AND auth.role() = 'authenticated')
        `,
        policy_permissions: 'DELETE'
      });

      if (deletePolicyError) {
        console.error('Error creating delete policy:', deletePolicyError);
      }
    }
  } catch (error) {
    console.error('Error setting up inspection photos bucket:', error);
  }
}

export async function getInspectionPhotos(bookingId: string, vehicleId: string) {
  if (!supabase) return [];

  try {
    const { data, error } = await supabase.storage
      .from('inspection-photos')
      .list(`${bookingId}/${vehicleId}`);

    if (error) throw error;

    return data.map(file => {
      const rawUrl = supabase!.storage.from('inspection-photos').getPublicUrl(`${bookingId}/${vehicleId}/${file.name}`).data.publicUrl;
      // Replace the default Supabase URL with custom domain
      const customUrl = rawUrl.replace(
        'https://idvgoctfaarxiryxprpy.supabase.co',
        'https://api.gitbooked.com'
      );
      return {
        url: customUrl,
      id: `${bookingId}/${vehicleId}/${file.name}`
      };
    });
  } catch (error) {
    console.error('Error getting inspection photos:', error);
    return [];
  }
} 